import { EditMetadata } from "@nens/brostar/uploadapi-client";
import { Task } from "@nens/brostar/uploadapi-client";

import { AnyFormProps, emptySymbol } from "../types/form-types";

// 1. Utility to extract all keys from a union
type AllKeys<T> = T extends unknown ? keyof T : never;

// 2. Ensure given keys are present (as undefined if missing)
type EnsureKeys<T, K extends string | typeof emptySymbol> = T &
  Record<Exclude<K, keyof T>, undefined>;

// 3. Complete any partial props with all possible keys from AnyFormProps
type CompleteFormValues<T> = EnsureKeys<T, AllKeys<AnyFormProps>>;

// 4. Final type distributing over union types
type FormValues<T extends AnyFormProps> = T extends unknown ? CompleteFormValues<T> : never;

export const getFormObjectValues = <T extends AnyFormProps>(props: T) => {
  return {
    task: "task" in props ? props.task : undefined,
    oldUploadTask: "oldUploadTask" in props ? props.oldUploadTask : undefined,
    requestType: "requestType" in props ? props.requestType : undefined,
    broId: "broId" in props ? props.broId : "",
    uuid: "uuid" in props ? props.uuid : undefined,
    type: "type" in props ? props.type : undefined,
  } as FormValues<T>;
};

type Edit<T> = T & {
  metadata: EditMetadata;
};
type SomeTask = Task<object, object> | { metadata: object };
export const initializeFormEditingState = <T extends AnyFormProps = AnyFormProps>(props: T) => {
  const { type, requestType } = getFormObjectValues(props);

  const isEditing = type === "edit" || requestType === "replace";

  const getIsEditing = <InitialValues extends SomeTask>(
    _values: InitialValues | Edit<InitialValues>
  ): _values is Edit<InitialValues> => {
    return isEditing;
  };

  return {
    isEditing,
    getIsEditing,
  };
};
